/* 布局 */
//前台
import Layout from "@views/layout";

const friendshiplinkRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "friendshiplink",
            name: "FRIENDSHIPLINK",
            meta: {
                title: "友情链接",
                sort: 1,
            },
            component: () => import("@views/business/friendshiplink/index.vue"),
            redirect: {
                name: "FRIENDSHIPLINK_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "FRIENDSHIPLINK_LIST",
                    meta: {
                        title: "友情链接",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/friendshiplink/list.vue"),
                },
                                {
                    path: "add",
                    name: "FRIENDSHIPLINK_ADD",
                    meta: {
                        title: "新增友情链接",
                        parentPath: '/business/friendshiplink/list',
                        operate: true,
                    },
                    component: () => import("@views/business/friendshiplink/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "FRIENDSHIPLINK_EDIT",
                    meta: {
                        title: "编辑友情链接",
                        parentPath: '/business/friendshiplink/list',
                        operate: true,
                    },
                    component: () => import("@views/business/friendshiplink/form.vue"),
                },
                                        ],
    },


        ],
};

export default friendshiplinkRouter;
